import { Resolver, ValidationMode } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { fleetInquirySchema } from "@/utils/validation/fleetInquirySchema";

export const dealerDefaultValues = {
  // First step
  firstName: "",
  lastName: "",
  fleetUsageCompanyName: "",
  email: "",
  address: "",
  city: "",
  zipCode: "",
  idCountry: 1,
  idState: 0,
  phoneNumber: "",

  // Second step
  businessType: "",
  numberOfVehicles: 0,

  // Third step
  customFeatures: "",
  timeTable: 3 as TestDrive,

  // Fourth step
  hoursFrom: "1000",
  hoursTo: "1800",
  preferredMode: 0 as Communication,
};

export const formConfig = {
  resolver: yupResolver(fleetInquirySchema) as Resolver<IFleetInquiryForm>,
  mode: "all" as keyof ValidationMode,
  defaultValues: dealerDefaultValues,
};
